export default "__VITE_ASSET__CvB78rmw__"